<template>
    <div v-loading="loading2" class="content">
        <div class="tips" v-if="isTip1">
            <p>系统检索无许可证复印件资料，请抓紧上传未加盖原件一致章和签名的许可证复印件否则案件电子版将无法上报！</p>
            <el-button type="primary" @click="getTip1()">确定</el-button>
        </div>
        <div class="tips" v-if="isTip2">
            <p>请不要忘记打开执法记录仪记录询问全过程！</p>
            <el-button type="primary" @click="getTip2()">确定</el-button>
        </div>
        <div  v-if="isTip3" style="min-height:500px;">
            <h2>被询问人身份</h2>
            <el-form :model="form" ref="form" :rules="rules" label-width="140px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="请选择询问笔录:" prop="xwbl">
                            <el-select v-model="form.xwbl" size="small" @change="getBl()">
                                <el-option
                                    v-for="dict in xwblOptions"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                             <!-- -->
                            <el-button v-show="blname.indexOf('(') != '-1' ? true : false" type="danger" style="width:280px; margin-bottom:20px;" @click="getEdit()">修改</el-button>
                        <br/><el-button type="primary" :disabled="blname.indexOf('(') != '-1' ? true : false" style="width:280px; margin-bottom:20px;" @click="getSf('（法定代表人/负责人/经营者）本人',1)">（法定代表人/负责人/经营者）本人</el-button>
                        <br/><el-button type="primary" :disabled="blname.indexOf('(') != '-1' ? true : false" style="width:280px; margin-bottom:20px;" @click="getSf('委托代理人',2)">委托代理人</el-button>
                        <br/><el-button type="primary" :disabled="blname.indexOf('(') != '-1' ? true : false" style="width:280px;" @click="getSf('案件其他相关人员',3)">案件其他相关人员</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div  v-if="isTip4">
            <!-- <el-form>
                <el-form-item label="微信选择：">
                    <el-select v-model="wx" placeholder="" size="small"  style="width:200px;">
                        <el-option
                            v-for="dict in wxOptions"
                            :key="dict.openid"
                            :label="dict.nickname"
                            :value="dict.openid"
                            ></el-option>
                    </el-select>&nbsp;
                    <el-button size="small" type="primary" >手机获取身份证信息</el-button>
                    <el-button size="small" type="primary" >读卡器获取身份证信息</el-button>
                </el-form-item>
            </el-form> -->
            <h2>询问笔录</h2>
            <el-form :model="form" ref="form" :rules="rules" label-width="120px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="被询问人身份:" prop="sf">
                            <span>{{form.sf}}</span>&nbsp;
                            <el-select v-model="xwsf" size="small" @change="getXwsf()">
                                <el-option
                                    v-for="(dict,index) in sfOptions"
                                    :key="index"
                                    :label="dict.label"
                                    :value="dict.value" 
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="被询问人:" prop="fzr">
                            <el-input style="width:140px;"
                            v-model="form.fzr"
                            placeholder="请输入被询问人"
                            clearable
                            size="small"
                            />&nbsp;
                            <el-select v-model="form.frxb" placeholder="性别" size="small"  style="width:80px;">
                                <el-option
                                    v-for="dict in xbOptions"
                                    :key="dict.id"
                                    :label="dict.label"
                                    :value="dict.label"
                                    ></el-option>
                            </el-select>&nbsp;
                            <el-select v-model="form.nation" placeholder="民族" size="small" style="width:120px;">
                                <el-option
                                    v-for="dict in mzOptions"
                                    :key="dict.id"
                                    :label="dict.nation"
                                    :value="dict.xh"
                                    ></el-option>
                            </el-select>&nbsp;
                            <el-input style="width:80px;"
                            v-model="form.nianling"
                            placeholder="年龄"
                            clearable
                            size="small"
                            /> 岁
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号:" prop="sfzh">
                            <el-input
                            v-model="form.sfzh"
                            placeholder="请输入身份证号"
                            clearable
                            size="small" @change="getSfzh()"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="住址:" prop="zhuzhi">
                            <el-input
                            v-model="form.zhuzhi"
                            placeholder="请输入住址"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="单位名称:" prop="dwmc">
                            <el-input
                            v-model="form.dwmc"
                            placeholder="请输入单位名称"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职务:" prop="frzw">
                            <el-select v-model="form.frzw" placeholder="请选择职务" size="small" style="width:120px;">
                                <el-option
                                    v-for="dict in zwOptions"
                                    :key="dict.px"
                                    :label="dict.zw"
                                    :value="dict.zw"
                                    ></el-option>
                            </el-select>
                            <el-input v-if="form.frzw == '其他'"
                            v-model="form.frzw_qita"
                            placeholder=""
                            clearable
                            size="small" style="width:140px;"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话:" prop="sj1">
                            <el-input
                            v-model="form.sj1"
                            placeholder="请输入联系电话"
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                    <el-col :span="12">
                        <el-form-item label="询问机关:">
                            <el-input disabled
                            v-model="c_org"
                            placeholder=""
                            clearable
                            size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"></el-col>
                    <el-col :span="24">
                        <el-form-item label="询问时间:" prop="xwdd">
                            <el-date-picker size="small"
                                v-model="form.xwrq"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>&nbsp;
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="起始时间" format="HH:mm"
                                value-format="HH:mm"
                                v-model="form.startTime">
                            </el-time-picker>&nbsp;至
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="结束时间" format="HH:mm"
                                value-format="HH:mm"
                                v-model="form.endTime">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="询问地点:" prop="kslxdz">
                            <el-select v-model="form.kslxdz" placeholder="" size="small">
                            <el-option
                                v-for="(dict,index) in ksdzOptions"
                                :key="index"
                                :label="dict.kslxdz"
                                :value="dict.kslxdz"
                                ></el-option>
                        </el-select>&nbsp;
                        <el-input
                            v-model="form.didian"
                            placeholder=""
                            clearable
                            size="small" style="width:120px;"
                            />
                            室
                            <!-- <el-checkbox v-model="isXz">通过远程询问系统询问</el-checkbox> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="询问内容:" >
                            <div>
                                <span>我们是{{c_org}}卫生执法人员</span>
                                <el-select v-model="form.jdy1" placeholder="主办人" size="small"  style="width:100px;" @change="getZfzh(form.jdy1,1)">
                                    <el-option
                                    v-for="(dict,index) in jdyOptions"
                                :key="index"
                                        :label="dict.xm"
                                        :value="dict.xm"
                                        ></el-option>
                                </el-select>
                                <span>、</span>
                                <el-select v-model="form.jdy2" placeholder="协办人" size="small"  style="width:100px;" @change="getZfzh(form.jdy2,2)">
                                    <el-option
                                    v-for="(dict,index) in jdyOptions"
                                :key="index"
                                        :label="dict.xm"
                                        :value="dict.xm"
                                        ></el-option>
                                </el-select>
                                <span>， 现场出示《浙江省行政执法证》（证号：</span>
                                <el-input disabled   style="width:160px;"
                                    v-model="form.jdyZfz1"
                                    placeholder="执法证1"
                                    clearable
                                    size="small"
                                />
                                <span>、</span>
                                <el-input disabled  style="width:160px;"
                                    v-model="form.jdyZfz2"
                                    placeholder="执法证2"
                                    clearable
                                    size="small"
                                />
                                <span>），现依法对你进行询问。你应当如实回答我们的询问并协助调查，不得提供虚假证言，不得伪造、隐匿、毁灭证据，否则将承担法律责任。你有权就询问事项自行提供书面材料，有权拒绝回答与案件无关的问题，有权核对询问笔录，对笔录记载有误或者遗漏之处提出更正或者补充意见，如果你回答的内容涉及国家机密、商业秘密或者个人隐私，本机关将予以保密。同时，根据《中华人民共和国行政处罚法》的规定，你有权利陈述或申辩。对办案人员有下列情形之一的，你及你的法定代理人有权申请回避：（一）是本案的当事人或者是当事人的近亲属；（二）本人或者其近亲属和本案有利害关系的；（三）与本案当事人有其他关系，可能影响案件公正处理的；（四）是本案的证人或者鉴定人。</span>
                            </div>
                            <div v-for="(v,i) in Ask_data" :key="i">
                                <el-col :span="23" align="left">
                                <p style="width:95%;">
                                    <span v-if="i > 1" style="position:relative; width:28px;height: 40px;float: left;">
                                        <span style="position: absolute;width: 28px;height: 15px;"><i @click="GoUp(i)" style="font-size:28px;color:#2a92eb;line-height:15px;" class="el-icon-caret-top"></i></span>
                                        <span style="position: absolute;width: 28px;height: 15px;top: 15px;"><i @click="Godown(i)" style="font-size:28px;color:#2a92eb;line-height:15px;" class="el-icon-caret-bottom"></i></span>
                                    </span>
                                    {{v.text1}}
                                    <el-button type="primary" plain v-if="v.text1=='请介绍下你的个人情况？'||v.ask=='请介绍下你的个人情况？'"  @click="getuserAuto(i)" size="mini">自动生成个人情况描述</el-button>
                                    <span style="display:inline-block;float:right;">
                                    <!-- <el-button type="success" @click="send_question(i)" size="mini">发送问题</el-button> -->
                                    <el-button type="primary" @click="edit_question(i)"  size="mini">编辑问题</el-button>
                                    <el-button type="danger" @click="del_question(i)"  size="mini">删除问题</el-button>
                                    </span>
                                </p>
                                </el-col>
                                <el-col :span="22" align="right">
                                <!-- <p>
                                    <el-button type="success" @click="send_question(i)" size="mini">发送问题</el-button>
                                    <el-button type="primary" @click="edit_question(i)"  size="mini">编辑问题</el-button>
                                    <el-button type="danger" @click="del_question(i)"  size="mini">删除问题</el-button>
                                </p> -->
                                </el-col>
                                <el-col :span="22" align="left">
                                <el-form-item>
                                    <el-input v-model="v.text2" type="textarea" @input="renew($event)"
                                    :rows="4"></el-input>
                                </el-form-item>
                                </el-col>
                            </div>
                            
                            <!--  <el-col :span="12" align="left" style="padding-left:20px;">
                                {{item.itemName}}
                            </el-col>
                            <el-col :span="11" align="right">
                                <el-button type="success" size="mini" @click="table_add({},1,item)" style="margin-bottom: 10px">新增
                                </el-button>
                            </el-col> -->
                            <!-- <el-col>
                                <el-table :data="table_nowData">
                                <el-table-column v-for="(row, index2) in table_nowColumn" :label="row.title" align="center"
                                                :prop="row.key" :width="row.width"/>

                                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                                    <template slot-scope="scope">
                                    <el-button
                                        size="mini"
                                        type="text"
                                        icon="el-icon-edit"
                                        @click="table_add(scope.row,2,item)"
                                        v-hasPermi="['hnba:approvalprocess:edit']"
                                    >修改
                                    </el-button>
                                    <el-button
                                        size="mini"
                                        type="text"
                                        icon="el-icon-delete"
                                        @click="table_del(scope.row,item.itemName)"
                                        v-hasPermi="['hnba:approvalprocess:remove']"
                                    >删除
                                    </el-button>
                                    </template>
                                </el-table-column>
                                </el-table>
                            </el-col> -->
                        </el-form-item>
                        <div style="text-align:right;">
                            <el-button type="danger" size="small" @click="add_question({},1)" style="margin-bottom: 10px">新增问题</el-button>
                            <el-button type="warning" size="small" @click="export_question()" style="margin-bottom: 10px">导入问答</el-button>
                        </div>
                        <el-col :span="24">
                            <el-form-item label="签名方式">
                                <el-radio-group v-model="form.sign">
                                    <el-radio :label="1">电子签名</el-radio>
                                    <el-radio :label="2" >手工签名</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    
                <el-col :span="24">
                <el-form-item style="text-align:center;">
                    <el-button type="info" @click="submit('form',2)">暂存</el-button>
                    <el-button type="primary" @click="submit('form',1)">生成询问笔录</el-button>

                    <el-button type="warning" @click="show()">预览</el-button>
                    <el-button type="danger" v-if="blLsh" @click="edit()">编辑</el-button>
                </el-form-item>
                </el-col>
                </el-row>
            </el-form>
        </div>
        <!--//表格表单-->
        <el-dialog title="新增问题" :visible.sync="mbVisible" width="1200px" append-to-body>
            <el-form  :model="form2" ref="editTable" label-width="100px">
                <el-row>
                    <el-col :span="11">
                        <!-- <el-form-item label="微信选择：">
                            <el-select v-model="wx" placeholder="" size="small"  style="width:200px;">
                                <el-option
                                    v-for="dict in wxOptions"
                                    :key="dict.openid"
                                    :label="dict.nickname"
                                    :value="dict.openid"
                                    ></el-option>
                            </el-select>&nbsp;
                            <el-button size="small" type="primary" @click="get_question">获取问题</el-button>
                            <el-button size="small" @click="gzgzh">关注公众号</el-button>
                        </el-form-item> -->
                        <el-form-item label="问：">
                            <el-input v-model="new_question" type="textarea" placeholder="请勾选询问笔录问题"
                                :rows="16" @input="renew($event)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1">
                    <div style="height:100px;"></div></el-col>
                    <el-col :span="12">
                        <el-button size="small" type="primary">询问笔录模板详细内容</el-button>
                        <el-form-item label="专业类别：" class="mb">
                            <el-select v-model="form2.zylb" placeholder="" size="small" @change="getMbnr()">
                                <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.zylb"
                                :label="dict.zylb"
                                :value="dict.zylb"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="案由：" class="mb">
                            <el-select v-model="form2.anyou" placeholder="" size="small"  @change="getMbnr2()" style="width:90%;">
                                <el-option
                                    v-for="dict in anyouOptions"
                                    :key="dict.anyou"
                                    :label="dict.anyou"
                                    :value="dict.anyou"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="关键词：" class="mb">
                            <el-select v-model="form2.gjc" placeholder="" size="small"  @change="getMbnr3()" style="width:90%;">
                                <el-option
                                    v-for="dict in gjcOptions"
                                    :key="dict.key"
                                    :label="dict.key"
                                    :value="dict.key"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <ul class="news" v-if="newsList.length > 0">
                            <li v-for="(item,index) in newsList" :key="index">
                            <span>{{item.wenti}}</span><el-checkbox v-model="item.checked" @change="getMbtext(item)"></el-checkbox>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit_question">确 定</el-button>
                <el-button @click="cancel_question">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改问题" :visible.sync="editVisible" width="800px" append-to-body>
            <el-form ref="editTable">
                <el-form-item label="">
                <el-col :span="23">
                    <el-input v-model="new_question" type="textarea" placeholder="请输入问题"
                        :autosize="{minRows:4, maxRows:5}" @input="renew($event)"></el-input>
                </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit_question">确 定</el-button>
                <el-button @click="cancel_question">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入问答" :visible.sync="exportVisible" width="800px" append-to-body>
            <p style="color:#ff0000;font-weight:bold; margin-bottom:10px;">* 请严格按照如下示例输入内容！注意冒号必须使用中文格式!</p>
            <p>问：XXXX</p>
            <p>答：XXXX</p>
            <el-form ref="editTable">
                <el-form-item label="">
                <el-col :span="23">
                    <el-input v-model="new_question2" type="textarea" placeholder="请输入问题"
                        :rows="8"></el-input>
                </el-col>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit_question2">确 定</el-button>
                <el-button @click="cancel_question">取 消</el-button>
            </div>
        </el-dialog>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="询问笔录" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','pcId','jingyingzhe'],
    data() {
        return {
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            loading:false,
            loading2:false,
            isTip1:false,
            isTip2:false,
            isTip3:false,
            isTip4:false,
            form:{
                xwbl:1,
                sf:'',
                xwsf:'',
                changsuo: '',
                dwdz: '',
                dwmc: '',
                frxb: '',
                frzw: '',
                fzr: '',
                jingyingzhe: '',
                jingyingzhexm: '',
                nation: '',
                sfzh: '',
                sj1: '',
                xiangjiedao: '',
                zhuzhi: '',
                zjtype: '',
                nianling:'',
                xwrq:'',
                startTime:'',
                endTime:'',
                jdy1:'',
                jdy2:'',
                jdyZfz1:'',
                jdyZfz2:'',
                kslxdz:[],
                sign:1,
                wxname:'',
                openid:'',
                frzw_qita:'',
                didian:''
            },
            isXz:false,
            rules:{
                sf:[
                    { required: true, message: '被询问人身份不能为空', trigger: ['blur','change'] },
                ],
                fzr:[
                    { required: true, message: '被询问人不能为空', trigger: 'blur' },
                ],
                frxb:[
                    { required: true, message: '性别不能为空', trigger: 'blur' },
                ],
                nation:[
                    { required: true, message: '民族不能为空', trigger: 'blur' },
                ],
                nianling:[
                    { required: true, message: '年龄不能为空', trigger: 'blur' },
                ],
                sfzh:[
                    { required: true, message: '身份证号不能为空', trigger: 'blur' },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '证件号码格式有误！',
                        trigger: 'blur'
                    }
                ],
                zhuzhi:[
                    { required: true, message: '住址不能为空', trigger: 'blur' },
                ],
                dwmc:[
                    { required: true, message: '单位名称不能为空', trigger: 'blur' },
                ],
                frzw:[
                    { required: true, message: '职务不能为空', trigger: ['blur','change'] },
                ],
                sj1:[
                    { required: true, message: '联系电话不能为空', trigger: 'blur' },
                ],
                kslxdz:[
                    { required: true, message: '询问地点不能为空', trigger: 'blur' },
                ],
            },
            xbOptions:[
                {id:1,label:'男'},
                {id:2,label:'女'}
            ],
            mzOptions:[],
            zwOptions:[],
            xwblOptions:[],
            xwsf:'',
            sfOptions:[
                {value:'（法定代表人/负责人/经营者）本人',label:'（法定代表人/负责人/经营者）本人',bm:0},
                {value:'委托代理人',label:'委托代理人',bm:1},
                {value:'案件其他相关人员',label:'案件其他相关人员',bm:2}
            ],
            jdyOptions: [], 
            Ask_data:[
                {
                    text1: '你听明白了吗？',
                    text2: '听明白了。'
                },
                {
                    text1: '是否需要申请上述执法人员回避？',
                    text2: '不需要申请上述执法人员回避。'
                },
                {
                    text1: '请介绍下你的个人情况？',
                    text2: ''
                },
                {
                    text1: '《现场笔录》是否属实？',
                    text2: ''
                }
            ],
            new_question:'',
            editVisible:false,
            question_index:'',
            mbVisible:false,
            wx:'',
            wxOptions:[],
            form2:{},
            zylbOptions:[],
            anyouOptions:[],
            gjcOptions:[],
            newsList:[],
            exportVisible:false,
            new_question2:'',
            c_org:'',
            ksdzOptions:[],
            fzrxx:[],
            jdyxx:[],
            isBtn:false,
            blLsh:'',
            blname:'',
            zws:'',
            bcfs:'',
            sfbm:'',
            wsUrl:'',
            dwXx:{},
            new_daan:'',

            isWs:false,
            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
        this.isTip1 = false
        this.isTip2 = false
        this.isTip3 = false
        this.isTip4 = false
        this.getList()
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.zws = ''
        axios({
            method: 'post',
            url: `https://xxswj.hzxhykj.com:9086/login/getzhiwu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zwOptions = res.data.data
                this.zwOptions.forEach(item => {
                    this.zws += item.zw
                })
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })   
        axios({
            method: 'post',
            url: `https://xxswj.hzxhykj.com:9086/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions = []
                let arr = res.data.data
                arr.forEach(item => {
                    let i = Number(item.id) < 10 ? '0'+item.id : item.id
                    this.mzOptions.push({id: item.id,nation: item.nation,px: item.px,xh:i})
                })
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })  
        let data3 = await this.$axios.get(`${this.Global._baseUrl2}?act=getXwblMbNeirong2&type=zylb&zylb=&anyou=&key=`)
        console.log(data3)
        if(data3.data){
            this.zylbOptions = data3.data
        }
        let date = new Date()
        let rq = this.getDate(date,'yyyy-MM-dd')
        let rq1 =  this.getDate(date,'hh:mm')
        let rq2 =  this.getDate(date,'hh:mm')
        this.$set(this.form,'xwrq',rq)
        this.$set(this.form,'startTime',rq1)
        this.$set(this.form,'endTime',rq2)
        // let data2 = await this.$axios.get(`${this.Global._baseUrl2}?act=getXwblMb`)
        // if(data2.data){
        //     this.zwOptions = data2.data
        // }
    },
    methods: {
        async getList(){
            this.loading2 = true
            //是否有许可证复议件
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getIsExistXkz&pcId=${this.pcId}`)
            if(data.data == '-1'){
                this.isTip1 = true
                this.isTip2 = false
            }else{
                this.isTip1 = false
                this.isTip2 = true
                
            }
            this.getZfxx()
            this.getXwbl()
            this.getTContact()
            // this.getksdizhi()
            this.getjdylist()
            this.getWxData()
            this.loading2 = false
            // let str=''
            // str+="我们是"+ this.orgname+"卫生执法人员"+this.jdy1+'、'+this.jdy2+"现场出示《河南省行政执法证》（证号："+ this.zfzh1+"、"+ this.zfzh2+"），现依法对你进行询问。"
            // str+="你应当如实回答我们的询问并协助调查，不得提供虚假证言，不得伪造、隐匿、毁灭证据，否则将承担法律责任。你有权就询问事项自行提供书面材料，有权拒绝回答与案件无关的问题，有权核对询问笔录，对笔录记载有误或者遗漏之处提出更正或者补充意见，如果你回答的内容涉及国家机密、商业秘密或者个人隐私，本机关将予以保密。同时，根据《中华人民共和国行政处罚法》的规定，你有权利陈述或申辩。对办案人员有下列情形之一的，你及你的法定代理人有权申请回避：（一）是本案的当事人或者是当事人的近亲属；（二）本人或者其近亲属和本案有利害关系的；（三）与本案当事人有其他关系，可能影响案件公正处理的；（四）是本案的证人或者鉴定人。你听明白了吗？是否需要申请上述执法人员回避？"
            // this.$set(this.Ask_data,0,{text1:str,text2:'听明白了，不需要申请上述执法人员回避。'})
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.dwXx = data.data[0]
            }
        },
        async getMbnr(){
            this.anyouOptions = []
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXwblMbNeirong2&type=anyou&zylb=${escape(this.form2.zylb)}&anyou=&key=`)
            console.log(data)
            if(data.data){
                this.anyouOptions = data.data
            }
        },
        async getMbnr2(){
            this.gjcOptions = []
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXwblMbNeirong2&type=key&zylb=${escape(this.form2.zylb)}&anyou=${escape(this.form2.anyou)}&key=`)
            console.log(data)
            if(data.data){
                this.gjcOptions = data.data
            }
        },
        async getMbnr3(){
            this.newsList = []
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXwblMbNeirong2&type=all&zylb=${escape(this.form2.zylb)}&anyou=${escape(this.form2.anyou)}&key=${escape(this.form2.gjc)}`)
            console.log(data)
            if(data.data){
                let arr = data.data
                arr.forEach(item => {
                    item.checked = false
                    this.newsList.push(item)
                })
            }
        },
        getMbtext(item){
            console.log(item)
            this.new_question = item.wenti
            this.new_daan = item.daan
        },
        getTContact() {
            this.ksdzOptions = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/login/GetTContact`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid,
                }
            })
            .then(response => {
                console.log(response.data);
                this.c_org = response.data.data.c_org || ''
                this.ksdzOptions.push({kslxdz:response.data.data.c_address})
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getjdylist() {
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid
                }
            })
            .then(response => {
                this.jdyOptions = response.data.data || []
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
        },
        async getWxData(page_size1,page1) {
            let page_size = page_size1 ? page_size1 : 30;
            let page = page1 ? page1 : 1;
            this.$axios({
                method: 'get',
                url: 'https://mse.bjklk.cn/gzh_wx_person/?page_size=' + page_size + '&page=' + page,
                async: false,
            }).then(res => {
                var arr = res.results;
                this.wxOptions = arr
            })
        },
        async getXwbl(){
            this.xwblOptions = []
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXunwenbilu&id=${this.pcId}&xm=${escape(this.xm)}`)
            console.log(data)
            if(data.data){
                this.isBtn = true
                if(data.data[0].xwbl_nr !== ''){
                    this.clickstatus = false
                }else{
                    this.clickstatus = true
                }
                let res = data.data
                for (var i = 0; i < 100; i++) {
                    if (i == 0) {
                        var name = res[i].xwbl_nr.indexOf('|')!='-1' ? res[i].xwbl_nr.split('|')[3].split('*')[1] : ''
                        this.xwblOptions.push({label:'询问笔录(' + name + ')',value:(i + 1),lsh:res[i].lsh})
                    } else {
                        if (i < data.data.length) {
                            var name = res[i].xwbl_nr.indexOf('|')!='-1' ? res[i].xwbl_nr.split('|')[3].split('*')[1] : ''
                            this.xwblOptions.push({label:'询问笔录' + (i + 1) + '(' + name + ')',value:(i + 1),lsh:res[i].lsh})
                        } else {
                            this.xwblOptions.push({label:'询问笔录'+(i + 1),value:(i + 1),lsh:''})
                        }
                    }
                }
                this.form.xwbl = this.xwblOptions[0].value
                this.blLsh = this.xwblOptions[0].lsh
                this.blname = this.xwblOptions[0].label
            }else{
                for(var i=1;i<101;i++){
                    this.xwblOptions.push({label:'询问笔录'+i,value:i,lsh:''})
                }
                this.form.xwbl = this.xwblOptions[0].value
                this.blLsh = ''
                this.blname = this.xwblOptions[0].label
            }
        },
        getBl(){
            console.log(this.form.xwbl)
            let n = this.xwblOptions.findIndex(item => {
                return item.value == this.form.xwbl
            })
            this.blLsh = this.xwblOptions[n].lsh
            this.blname = this.xwblOptions[n].label
        },
        async getZfzh(jdy,val){
            let arr = this.jdyOptions.filter(item => {
                return item.xm === jdy
            })
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJdyZfzh&dm=${arr[0].dm}`)
            console.log(data)
            if(data.data){
                if(val == 1){
                    this.$set(this.form,'jdyZfz1',data.data[0].zfzh)
                }else if(val == 2){
                    this.$set(this.form,'jdyZfz2',data.data[0].zfzh)
                }
            }
        },
        getTip1(){
            this.isTip1 = false
            this.isTip2 = true 
        },
        getTip2(){
            this.isTip2 = false
            this.isTip3 = true
        },
        async getSf(text,val){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getDwxxByAjID&id=${this.pcId}`)
            if(data.data){
                this.fzrxx = data.data
            }
            let data2 = await this.$axios.get(`${this.Global._baseUrl2}?act=getjdyxx&id=${this.pcId}`)
            if(data2.data){
                this.jdyxx = data2.data
            }
            this.$confirm("被询问人员是否为笔录签字人员？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                this.isTip3 = false
                this.isTip4 = true
                this.form.sf = text  
                this.xwsf = text
                
                let obj = this.fzrxx[0]
                for(var i in this.form){
                    for(var p in obj){
                        if(i == p){
                            this.form[i] = obj[p]
                        }
                    }
                }
                if(!this.form.jdy1){
                    console.log(this.jdyxx)
                    this.$set(this.form,'jdy1',this.jdyxx[0].host_man)
                    this.$set(this.form,'jdyZfz1',this.jdyxx[0].zfzh1)
                }
                if(!this.form.jdy2){
                    console.log(this.jdyxx)
                    this.$set(this.form,'jdy2',this.jdyxx[0].cooperate_man)
                    this.$set(this.form,'jdyZfz2',this.jdyxx[0].zfzh2)
                }
                if(obj && obj.sfzh){
                    var str = obj.sfzh.substring(6, 10) + '/' + obj.sfzh.substring(10, 12) + '/' + obj.sfzh.substring(12, 14);
                    let nl = this.getAge(str);
                    console.log(nl)
                    if(!Number.isNaN(nl)){
                        console.log(nl)
                        this.$set(this.form,'nianling',Number(nl))
                    }
                    
                }
            })
        },
        async getEdit(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXunwenbilu&id=${this.pcId}&xwblLsh=${this.blLsh}&xm=${escape(this.xm)}`)
            console.log(data)
            console.log(this.bcfs)
            if(data.data){
                let xwbl_nr = data.data[0].xwbl_nr
                this.isTip3 = false
                this.isTip4 = true
                var arr = xwbl_nr.split('|');
                console.log(arr)
                let that = this
                let rq = ''
                let sj1 = ''
                let sj2 = ''
                arr.forEach(function (item) {
                    if (item.indexOf('*') >= 0) {
                        var pra = item.split('*');
                        
                        if (pra[0] === 'storeflag') {
                            // 暂存保存 // 1代表保存，2代表暂存
                            that.bcfs = pra[1]
                            // return false;
                        } else if (pra[0] === 'xwrsf') {
                            // 被询问人身份
                            that.sfbm = pra[1]
                            if (pra[1] == '0') {
                                that.xwsf = that.sfOptions[0].value
                                that.$set(that.form,'sf',that.sfOptions[0].value)
                            } else if (pra[1] == '1') {
                                that.xwsf = that.sfOptions[1].value
                                that.$set(that.form,'sf',that.sfOptions[1].value)
                            } else if (pra[1] == '2') {
                                that.xwsf = that.sfOptions[2].value
                                that.$set(that.form,'sf',that.sfOptions[2].value)
                            }
                            console.log(pra[1])
                            console.log(that.form.sf)
                            // return false;
                        } else if (pra[0] === 'national') { 
                            that.mzOptions.forEach(item => {
                                if(item.nation == pra[1] || item.xh == pra[1]){
                                    that.$set(that.form,'nation',item.xh) 
                                }
                            })
                        }else if (pra[0] === 'time0') { 
                            that.$set(that.form,'xwrq',pra[1]) 
                            rq = pra[1]
                        }else if (pra[0] === 'time') { 
                            sj1 = pra[1]
                        }else if (pra[0] === 'time2') { 
                            sj2 = pra[1]
                        }else if (pra[0] === 'zfzh1') {
                            // 执法证号
                            that.$set(that.form,'jdyZfz1',pra[1])
                            // return false;
                        } else if (pra[0] === 'zfzh2') {
                            // 执法证号
                            that.$set(that.form,'jdyZfz2',pra[1])
                            // return false;
                        } else if (pra[0] === 'sign') {
                            // 执法证号
                            that.$set(that.form,'sign',Number(pra[1]))
                            console.log(that.form.sign)
                            // return false;
                        }  else if (pra[0] === 'openid') {
                            // 执法证号
                            that.$set(that.form,'openid',pra[1])
                            // return false;
                        } else if (pra[0] === 'frzw') {
                            // 职务
                            if (that.zws.indexOf(pra[1]) < 0) {
                                that.$set(that.form,'frzw','其他')
                                if (pra[1] == 'null' || pra[1] == '请选择') {
                                    that.$set(that.form,'frzw_qita','')
                                }
                                else
                                { that.$set(that.form,'frzw_qita',pra[1])}
  
                            }else{
                                that.$set(that.form,'frzw',pra[1])
                            }
                        } else if (pra[0] === 'host_man') {
                            that.$set(that.form,'jdy1',pra[1])
                        } else if (pra[0] === 'cooperate_man') {
                            that.$set(that.form,'jdy2',pra[1])
                        } else if (pra[0] === 'didian') {
                            if (pra[1].indexOf('@') != -1) {
                                var shi = pra[1].split('@')
                                that.$set(that.form,'kslxdz',shi[0])
                                that.$set(that.form,'didian',shi[1])
                                if(shi[2] == '通过远程询问系统询问'){
                                    that.isXz = true
                                }else{
                                    that.isXz = false
                                }
                            } else {
                                that.$set(that.form,'kslxdz',pra[1])
                            }
                        } else{
                            that.$set(that.form,pra[0],pra[1])
                        }
                    } else if (item.indexOf('@') >= 0) {
                        var arr = item.split('@');
                        console.log(arr)
                        let  n = that.Ask_data.findIndex(item => {
                            return item.text1 == arr[0]
                        })
                        console.log(n)
                        if(n >= 0){
                            that.Ask_data.forEach(item => {
                                if(item.text1 == arr[0]){
                                    item.text2 = arr[1]
                                }
                            })
                        }else{
                            that.Ask_data.push({text1:arr[0],text2:arr[1]})
                            console.log(that.Ask_data)
                        }
                        console.log(that.Ask_data)
                    }
                    
                })
                that.$set(that.form,'startTime',rq + ' '+sj1)
                that.$set(that.form,'endTime',rq + ' '+sj2) 
                that.$forceUpdate()
            }
        },
        // 计算年龄
        getAge(birthday) {
            //出生时间 毫秒
            var birthDayTime = new Date(birthday).getTime();
            //当前时间 毫秒
            var nowTime = new Date().getTime();
            //一年毫秒数(365 * 86400000 = 31536000000)
            return Math.ceil((nowTime - birthDayTime) / 31536000000) - 1;
        },
        getXwsf(){
            this.form.sf = this.xwsf
        },
        getSfzh(){
            if(this.form.sfzh){
                console.log(this.form.sfzh)
                let nl = this.getAge(this.form.sfzh+'');
                console.log(nl)
                if(!Number.isNaN(nl)){
                    console.log(nl)
                    this.form.nianling = Number(nl)
                }
            }
        },
        testid(id) {
            // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
            var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
            //号码规则校验
            if(!format.test(id)){
            return {'status':0,'msg':'身份证号码不合规'};
            }
            //区位码校验
            //出生年月日校验  前正则限制起始年份为1900;
            var year = id.substr(6,4),//身份证年
            month = id.substr(10,2),//身份证月
            date = id.substr(12,2),//身份证日
            time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
            now_time = Date.parse(new Date()),//当前时间戳
            dates = (new Date(year,month,0)).getDate();//身份证当月天数
            if(time>now_time||date>dates){
            return {'status':0,'msg':'出生日期不合规'}
            }
            //校验码判断
            var c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);  //系数
            var b = new Array('1','0','X','9','8','7','6','5','4','3','2'); //校验码对照表
            var id_array = id.split("");
            var sum = 0;
            for(var k=0;k<17;k++){
            sum+=parseInt(id_array[k])*parseInt(c[k]);
            }
            if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
            return {'status':0,'msg':'身份证校验码不合规'}
            }
            return {'status':1,'msg':'校验通过'}
        },
        add_question(i){
            this.title = '询问问题'
            this.mbcode ='16'
            this.mbVisible = true
        },
        edit_question(i){
            this.editVisible=true
            this.new_question=this.Ask_data[i].text1
            this.question_index=i
        },
        send_question(i){
            if(this.opend_id==''){
            this.$message.error('请在公众号输入询问验证码。');
            return false;
            }
            //发送问题
            // gzhWxAsk({ openid: this.opend_id,ask: this.Ask_data[i].text1}).then(response => {
            // this.getQuestion = true;
            // this.question_index=i
            // })
        },
        getQuestionText(id){
            gzhWxAnswer(id).then(response => {
            if(response.openid==this.opend_id){
                let res=''
                response.ask_voice.map((item,index)=>{
                if (index==0) {
                    res += item.answer
                } else {
                    res += '\n' + item.answer
                }
                })
                this.Ask_data[this.question_index].text2=res
                this.$forceUpdate()
            }
            })
        },
        submit_question(){
            if(!this.new_question){
                this.$message.error('请勾选询问笔录问题！')
            }else{
                if(this.question_index){
                    console.log(this.Ask_data,this.question_index)
                    this.Ask_data[this.question_index].text1=this.new_question
                    this.editVisible=false
                }else{
                    this.Ask_data.push({text1:this.new_question,text2:this.new_daan})
                    this.mbVisible=false
                }
                this.$forceUpdate()
            }
            
        },
        submit_question2(){
            console.log(this.new_question2)
            if(this.new_question2){
                if(this.new_question2.indexOf('问：') != -1){
                    let arr = this.new_question2.split('问：')
                    console.log(arr)
                    if(arr[1].indexOf('答：') != -1){
                        let arr1 = arr[1].split('答：')
                        console.log(arr1)
                        let str =  arr1[0].replace(/\n/g, "");
                        console.log(str)
                        this.Ask_data.push({text1:str,text2:arr1[1]})
                        this.exportVisible=false
                    }else if(arr[1].indexOf('答:') != -1){
                        let arr1 = arr[1].split('答:')
                        console.log(arr1)
                        let str =  arr1[0].replace(/\n/g, "");
                        console.log(str)
                        this.Ask_data.push({text1:str,text2:arr1[1]})
                        this.exportVisible=false
                    }else{
                        this.$message.error('请输入正确的问答格式！')
                        return false
                    }
                }else if(this.new_question2.indexOf('问:') != -1){
                    let arr = this.new_question2.split('问:')
                    console.log(arr)
                    if(arr[1].indexOf('答：') != -1){
                        let arr1 = arr[1].split('答：')
                        console.log(arr1)
                        let str =  arr1[0].replace(/\n/g, "");
                        console.log(str)
                        this.Ask_data.push({text1:str,text2:arr1[1]})
                        this.exportVisible=false
                    }else if(arr[1].indexOf('答:') != -1){
                        let arr1 = arr[1].split('答:')
                        console.log(arr1)
                        let str =  arr1[0].replace(/\n/g, "");
                        console.log(str)
                        this.Ask_data.push({text1:str,text2:arr1[1]})
                        this.exportVisible=false
                    }else{
                        this.$message.error('请输入正确的问答格式！')
                        return false
                    }
                }else{
                    this.$message.error('请输入正确的问答格式！')
                    return false
                }
                
            }else{
                this.$message.error('请输入内容！')
            }
        },
        cancel_question(){
            this.editVisible=false
            this.mbVisible = false
            this.exportVisible = false
        },
        GoUp(i){
            if(i==2){
                this.$message.error('当前问题为第一个，不能前移。');
                return false;
            }
            this.move(this.Ask_data, i-1, i);
        },
        Godown(i){
            if(i==this.Ask_data.length-1){
                this.$message.error('当前问题为最后一个，不能后移。');
                return false;
            }
            this.move(this.Ask_data, i, i+1);
        },
        move(arr, index1, index2) {
            arr[index1] = arr.splice(index2, 1, arr[index1])[0];
            return arr;
        },
        getuserAuto(i){
            let mz = this.mzOptions.filter(item => {
                return item.xh == this.form.nation || item.nation == this.form.nation
            })
            let zw = (this.jingyingzhe == '个人' || this.jingyingzhe == '公民') ? '' : this.form.dwmc + this.form.frzw + "，"
            this.Ask_data[i].text2="我叫" + this.form.fzr + "，" + this.form.frxb + "，" + this.form.nianling + "岁，" + mz[0].nation + "，身份证住址：" + this.form.zhuzhi + "，" + zw + "身份证号：" + this.form.sfzh + "。联系电话是" + this.form.sj1 + "。"
        },
        getIshd(){
            
        },
        submit(form,val){
            if(val == 1){
                if(this.form.fzr){
                    if (this.form.fzr.indexOf('@') != -1 || this.form.fzr.indexOf('*') != -1) {
                        this.$message.error('被询问人不能含有“@”、“*”字符，如不知被询问人姓名，请用“某某”替代。');
                        return false;
                    }
                }else{
                    this.$message.error('被询问人不能为空')
                    return false;
                }
                if(this.form.zhuzhi){
                    if (this.form.zhuzhi.indexOf('@') != -1 || this.form.zhuzhi.indexOf('*') != -1) {
                        this.$message.error('住址不能含有“@”、“*”字符。');
                        return false;
                    }
                }else{
                    this.$message.error('住址不能为空')
                    return false;
                }
                if(!this.form.sf){
                    this.$message.error('被询问人身份不能为空')
                    return false;
                }
                if(!this.form.frxb){
                    this.$message.error('性别不能为空')
                    return false;
                }
                if(!this.form.nation){
                    this.$message.error('民族不能为空')
                    return false;
                }
                if(!this.form.nianling){
                    this.$message.error('年龄不能为空')
                    return false;
                }
                if(!this.form.sfzh){
                    this.$message.error('身份证号不能为空')
                    return false;
                }else{
                    let reg=/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
                    if(!reg.test(this.form.sfzh)){
                        this.$message.error('身份证号格式有误')
                        return false;
                    }
                }
                if(!this.form.dwmc){
                    this.$message.error('单位名称不能为空')
                    return false;
                }
                if(!this.form.frzw){
                    this.$message.error('职务不能为空')
                    return false;
                }
                if(!this.form.sj1){
                    this.$message.error('联系电话不能为空')
                    return false;
                }
                if(!this.form.kslxdz){
                    this.$message.error('询问地点不能为空')
                    return false;
                }
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.submit1(val)
                    }else{
                        return false
                    }
                })
            }else{
                this.submit1(val)
            }
        },
        async submit1(val){
            
            console.log(this.form.sign)
            console.log(this.Ask_data)
            let arr = []
            this.Ask_data.forEach(item => {
                if(item.text2 == ''){
                    arr.push(item)
                }
            })
            if(arr.length > 0){
                this.$alert('请回答：'+arr[0].text1, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        // this.$message({
                        // type: 'info',
                        // message: ``
                        // });
                    }
                });
                return false
            }
            let nr = ''
            let mzarr = this.mzOptions.filter(item => {
                return item.xh == this.form.nation || item.nation == this.form.nation
            })
            let mz = mzarr[0].nation
            let sfarr = this.sfOptions.filter(item => {
                return item.value == this.xwsf
            })
            this.sfbm = sfarr[0].bm
            let zw = this.form.frzw=='其他' ? this.form.frzw_qita : this.form.frzw
            let didian = ''
            if(this.isXz){
                didian = this.form.kslxdz + '@' + this.form.didian + '@通过远程询问系统询问'
            }else{
                didian = this.form.kslxdz + '@' + this.form.didian + '@'
            }
            console.log(this.form.startTime,this.form.endTime)
            let sj1 = this.form.startTime  // this.getDate(this.form.startTime,'hh:mm')
            let sj2 = this.form.endTime   //this.getDate(this.form.endTime,'hh:mm')
            console.log(sj1,sj2)
            var data = {
                storeflag: val, // 1代表保存，2代表暂存
                xwrsf: this.sfbm, // 被询问人身份-代号
                sign: escape(this.form.sign),
                fzr: escape(this.form.fzr),
                frxb: escape(this.form.frxb),
                national: escape(mz),
                nianling: this.form.nianling,
                zhuzhi: escape(this.form.zhuzhi),
                sfzh: escape(this.form.sfzh),
                dwmc: escape(this.form.dwmc),
                frzw: escape(zw),
                sj1: escape(this.form.sj1),
                time0: escape(this.form.xwrq),
                time: escape(sj1),
                time2: escape(sj2),
                didian: escape(didian),
                host_man: escape(this.form.jdy1),
                cooperate_man: escape(this.form.jdy2),
                zfzh1: escape(this.form.jdyZfz1),
                zfzh2: escape(this.form.jdyZfz2),
                wxname: escape(this.form.wxname),
                openid: escape(this.form.openid),
            }

            Object.keys(data).forEach(function (item) {
                nr += (item + '*' + data[item] + '|');
            })
            console.log(this.Ask_data)      
            this.Ask_data.forEach(function (item, index) {
                if (item.text1.indexOf('@') != -1 || item.text1.indexOf('*') != -1) {
                    alert('问题中不能含有“@”、“*”字符。');
                    return false;
                } else if (item.text2.indexOf('@') != -1 || item.text2.indexOf('*') != -1) {
                    alert('回答中不能含有“@”、“*”字符。');
                    return false;
                } else {
                    nr += (escape(item.text1) + '@' + escape(item.text2).replace(/%0A/g, ',') + '|')
                    // nr += (escape(item.text1) + '@' + escape(item.text2).replace(/%0A/g, ',') + '@' + (item.biaohsi ? item.biaohsi : '') + '|')
                }
            })
            console.log(nr)
            nr = nr.slice(-1) == '|' ? nr.slice(0, -1) : nr
            this.loading = true

            console.log(this.blLsh)
            console.log(this.form.kslxdz,1375)
            axios({
                method: 'post',
                url: `${this.Global._baseUrl2}`,
                data: {
                    act: "saveXunwenbilu",
                    id: `${this.pcId}`,
                    xwblLsh:`${this.blLsh}`,
                    xwbl_nr: nr,
                    xwr1:`${escape(this.form.jdy1)}`,
                    xwr2:`${escape(this.form.jdy2)}`,
                    bxwr:`${escape(this.form.fzr)}`,
                    sign:1,
                    kslxdz:`${escape(this.form.kslxdz)}`,
                    c_mid:`${this.cmid}`,
                    xm:`${escape(this.xm)}`,
                    dm:`${this.dm}`,
                    shi:`${escape(this.shi)}`,
                    xianqu:`${escape(this.xianqu)}`,
                },
                transformRequest: [function (data) {
                    data = qs.stringify(data);
                    return data;
                }],
                headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
            }).then(res => {
                console.log(res)
                this.loading = false
                if(res.data != -1){
                    
                    if (res.data != '') {
                        this.isFsqm = true
                    } else {
                        this.isFsqm = false
                    }
                    if(val == 1){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            message: '暂存成功',
                            type: 'success'
                        });
                    }
                    this.blLsh = res.data
                    this.show()
                }else{
                    this.$message({
                        message: '保存失败，请重新填写',
                        type: 'error'
                    });
                }

            }).catch(res => {
                this.$message({
                    message: '保存失败，请重新填写',
                    type: 'error'
                });
                this.loading = false
            })
            // that.$emit('handleBack',1)
        },
        get_question(){},
        gzgzh(){},
        export_question(){
            this.exportVisible = true
            this.new_question2 = ''
        },
        renew(e){
            this.$forceUpdate()
        },
        del_question(i){
            this.$confirm("确定要选择这个问题吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
            })
            .then(() => {
            this.Ask_data.splice(i,1)
            })
            .catch(() => {
            this.$message({
                type: "info",
                message: "已取消操作"
            });
            });
        },
        show(){
            if(this.blLsh){
                console.log('1308')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:this.dwXx.dwmc_id,
                        lsh:this.dwXx.lsh,
                        wsname:'xunwenbilu',
                        blLsh:this.blLsh
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
            
        },

        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.blLsh){
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+this.dwXx.dwmc_id+'/'+this.dwXx.lsh+'/xunwenbilu'+this.blLsh+'.docx'
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.blLsh){
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+this.dwXx.dwmc_id+'/'+this.dwXx.lsh+'/tupian/xunwenbilu'+this.blLsh+'.pdf'
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'xunwenbilu'+this.blLsh+'.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dwXx.dwmc_id}&lsh=${this.dwXx.lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.tips{ min-height: 500px; text-align: center;}
.tips p{margin:100px 50px 30px;line-height: 80px; font-size: 24px;}
.news{border: solid 1px #dcdfe6; padding: 10px; border-radius: 3px; margin-top:10px;}
.news li{margin-bottom: 10px;}
.mb.el-form-item {
    margin-bottom: 5px !important;
}
  .el-timeline-item__timestamp {
    color: #2819f9;
    line-height: 1;
    font-size: 16px;
  }

  .content {
    padding: 10px 0;

  }
  .content .el-collapse-item {
    border: 1px solid #DCDFE5;
    margin-bottom: 20px;
  }

  .content .el-collapse-item__header {
    background: #eff2f9;
    padding: 0 20px;
    border-bottom: 1px solid #DCDFE5;
  }

  /* #content1 .el-collapse-item__content {
    padding: 20px 0 0 30px;
  } */

  .btn_group .el-form-item__content {
    margin-left: 20px !important;
  }

  .text_item .el-textarea__inner, .text_item .el-textarea__inner:focus {
    /* border:none; */
    margin-bottom: -10PX;
  }

  .tableForm {

  }

  .el-input.is-disabled .el-input__inner {
    background-color: white;
    border-color: #dfe4ed;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background-color: white;
    border-color: #dfe4ed;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .el-range-editor.is-disabled input {
    background-color: white;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .content >>> .el-input.is-disabled .el-input__inner { color: #333;}
</style>